module.exports = __webpack_public_path__ + "img/maintenance.f4b0ded1.png";